/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Rkid_HintInputs */

const cs_projects_rkid_hint = /** @type {(inputs: Projects_Rkid_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unikátní v rámci kanceláře. Inzeráty se napojí přes detaily trhu.`)
};

const en_projects_rkid_hint = /** @type {(inputs: Projects_Rkid_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unique per organization. Listings link via market details.`)
};

/**
* | output |
* | --- |
* | "Unique per organization. Listings link via market details." |
*
* @param {Projects_Rkid_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_rkid_hint = /** @type {((inputs?: Projects_Rkid_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Rkid_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_rkid_hint(inputs)
	return cs_projects_rkid_hint(inputs)
});